module.exports = __webpack_public_path__ + "media/images/version_merge/unsuccess-c03d0cff1ec2886f15bcdf647bc1fc00.svg";